import React from 'react';
import FAQ from '../components/FAQ';
import { Phone, MessageSquare } from 'lucide-react';
import { Button } from '../components/ui/button';
import { businessInfo } from '../data/mock';

const FAQPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Hero */}
      <section className="pt-32 pb-12 bg-gradient-to-r from-blue-900 to-blue-800">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-blue-100">
              Find answers to common questions about our garage door services
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Component */}
      <FAQ />

      {/* Still Have Questions CTA */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Still Have Questions?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Our friendly team is here to help. Give us a call or request a quote.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button 
              onClick={() => window.location.href = `tel:${businessInfo.phone}`}
              size="lg"
              className="bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-6"
            >
              <Phone size={20} className="mr-2" />
              Call {businessInfo.phone}
            </Button>
            <Button 
              onClick={() => window.location.href = '/quote'}
              size="lg"
              variant="outline"
              className="border-2 border-blue-800 text-blue-800 hover:bg-blue-800 hover:text-white font-bold px-8 py-6"
            >
              <MessageSquare size={20} className="mr-2" />
              Get Free Quote
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;